import React, { useRef, useState, useEffect } from 'react';
import { useFirestore } from '../contexts/FirestoreContext';
import { getAuth } from 'firebase/auth';
import { Form, Button, Col, Row, FloatingLabel, Spinner, OverlayTrigger, Tooltip, Modal, Table } from 'react-bootstrap';
//import { moveVehicleTeamsFolder } from '../utils/teamsUtils'; // Import the function

// Helper function to format numbers as currency
const formatCurrency = (value) => {
  // Remove any existing commas from the value before formatting
  if (isNaN(value) || value === null) return '';
  const numberValue = parseFloat(value.toString().replace(/,/g, '')); // Remove commas and parse
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(numberValue);
};

// Helper function to remove currency formatting (e.g., "$" and commas)
const parseCurrency = (value) => {
  if (!value) return 0;
  // Remove commas and any currency symbols like "$" then parse as a float
  return parseFloat(value.replace(/[$,]/g, '')) || 0;
};

function VehicleForm({ salesOrderNumber, onVehicleAdded, vehicle, onVehicleUpdated, onBulkEditSubmit, modelCodes, addVehicle=false }) {
  const auth = getAuth();
  const currentUser = auth.currentUser;
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [salesOrders, setSalesOrders] = useState([]);
  const [upfitterStatusOptions, setUpfitterStatusOptions] = useState([]);
  const [upfitters, setUpfitters] = useState([]);
  const [selectedSalesOrder, setSelectedSalesOrder] = useState(salesOrderNumber || '');
  const [originalSalesOrder, setOriginalSalesOrder] = useState(salesOrderNumber || '');
  const { addData, updateData, getData, queryData } = useFirestore();
  const [submitMessage, setSubmitMessage] = useState("");
  const [teamsLoading, setTeamsLoading] = useState(false);
  const [vehSalePrice, setVehSalePrice] = useState();
  const [vehMSRP, setVehMSRP] = useState();
  const [vehCOS, setVehCOS] = useState();
  const [rebate, setRebate] = useState();
  const [warrSale, setWarrSale] = useState();
  const [warrCost, setWarrCost] = useState();
  // Add additional state for tracking edit mode for each field
  const [editingVehSalePrice, setEditingVehSalePrice] = useState(false);
  const [editingVehMSRP, setEditingVehMSRP] = useState(false);
  const [editingVehCOS, setEditingVehCOS] = useState(false);
  const [editingRebate, setEditingRebate] = useState(false);
  const [editingWarrSale, setEditingWarrSale] = useState(false);
  const [editingWarrCost, setEditingWarrCost] = useState(false);
  const [editingTTFees, setEditingTTFees] = useState(false);
  const [editingVehIncent, setEditingVehIncent] = useState(false);
  const [editingDoas, setEditingDoas] = useState(false);
  const [editingAccess, setEditingAccess] = useState(false);
  const [ttFees, setTTFees] = useState(); // State for Tag and Title Fees
  const [vehIncent, setVehIncent] = useState();
  const [access, setAccess] = useState();
  const [doas, setDoas] = useState();
  const [vq2, setVQ2] = useState();
  const [taxes, setTaxes] = useState();
  const [transCost, setTransCost] = useState();
  const [upfitCost, setUpfitCost] = useState();
  const [editingVQ2, setEditingVQ2] = useState(false);
  const [editingTaxes, setEditingTaxes] = useState(false);
  const [editingTransCost, setEditingTransCost] = useState(false);
  const [editingUpfitCost, setEditingUpfitCost] = useState(false);
  const [manualStatus, setManualStatus] = useState('');
  const [manualETA, setManualETA] = useState(null);
  const [approved, setApproved] = useState(false);
  const [approvedBy, setApprovedBy] = useState('');
  const [arrAssistance, setArrAssistance] = useState([]);
  const [showAssistanceModal, setShowAssistanceModal] = useState(false);
  const [newBid, setNewBid] = useState('');
  const [newItem, setNewItem] = useState('');
  const [newAmount, setNewAmount] = useState('');
  // List of warranty rows + modal toggle
  const [arrWarranty, setArrWarranty] = useState([]);
  const [showWarrantyModal, setShowWarrantyModal] = useState(false);
  const [newWarrantyType, setNewWarrantyType] = useState('');
  const [newWarrantySale, setNewWarrantySale] = useState('');
  const [newWarrantyCost, setNewWarrantyCost] = useState('');
  const [arrRebates, setArrRebates] = useState([]);
  const [showRebateModal, setShowRebateModal] = useState(false);
  const [newRebateNumber, setNewRebateNumber] = useState('');
  const [newRebateAmount, setNewRebateAmount] = useState('');
  const [arrTradeIns, setArrTradeIns] = useState([]);
  const [showTradeModal, setShowTradeModal] = useState(false);
  const [newTradeVin, setNewTradeVin] = useState('');
  const [newTradeYear, setNewTradeYear] = useState('');
  const [newTradeMakeModel, setNewTradeMakeModel] = useState('');
  const [newTradeMiles, setNewTradeMiles] = useState('');
  const [newTradeACV, setNewTradeACV] = useState('');
  const [newTradeAllowance, setNewTradeAllowance] = useState('');
  const [newTradePayoff, setNewTradePayoff] = useState('');
  const [arrTransport, setArrTransport] = useState([]);
  const [showTransportModal, setShowTransportModal] = useState(false);
  const [newTransportDesc, setNewTransportDesc] = useState('');
  const [newTransportAmt, setNewTransportAmt] = useState('');
  const [approvedByName, setApprovedByName] = useState('');
  const [arrAccessories, setArrAccessories] = useState([]);
  const [showAccessoriesModal, setShowAccessoriesModal] = useState(false);
  const [newAccessoryDesc, setNewAccessoryDesc] = useState('');
  const [newAccessoryAmount, setNewAccessoryAmount] = useState('');
  const [finResrv, setFinResrv] = useState('');
  const [editingFinResrv, setEditingFinResrv] = useState(false);
  // NEW (Upfit Items)
  const [arrUpfitterItems, setArrUpfitterItems] = useState([]);
  const [showUpfitModal, setShowUpfitModal] = useState(false);
  const [newUpfitterName, setNewUpfitterName] = useState('');
  const [newUpfitDesc, setNewUpfitDesc] = useState('');
  const [newUpfitAmount, setNewUpfitAmount] = useState('');
  const [newUpfitterNbr, setNewUpfitterNbr] = useState('');
  const [newUpfitterStatus, setNewUpfitterStatus] = useState('');
  const [newUpfSent, setNewUpfSent] = useState(''); // YYYY-MM-DD
  const [newUpfETA, setNewUpfETA] = useState('');
  const [newUpfComp, setNewUpfComp] = useState('');
  const [arrUpfitters, setArrUpfitters] = useState([]); 
  const [userProfile, setUserProfile] = useState(null);


  // Refs for all the fields
  const ordNbrRef = useRef();
  const danRef = useRef();
  const poNbrRef = useRef();
  const poLineNbrRef = useRef();
  const vinRef = useRef();
  const stockNbrRef = useRef();
  const upfitterNbrRef = useRef();
  const upfitterStatusRef = useRef();
  const upfitterETARef = useRef();
  const upfitterCompRef = useRef();
  const yearRef = useRef();
  const makeRef = useRef();
  const engineTypeRef = useRef();
  const modelRef = useRef();
  const colorRef = useRef();
  const manStatRef = useRef();
  const dtManETARef = useRef();
  const dtProdDateRef = useRef();
  const dtPaidDateRef = useRef();
  const dropIndRef = useRef();
  const recvDateRef = useRef();
  const dropLocRef = useRef();
  const delivStatRef = useRef();
  const delivDateRef = useRef();
  const delivETARef = useRef();
  const billCDKRef = useRef();
  const rptDateRef = useRef();
  const recallRef = useRef();
  const dealNbrRef = useRef();
  const saleDateRef = useRef();
  const vehSalePriceRef = useRef();
  const vehMSRPRef = useRef();
  const vehCOSRef = useRef();
  const rebateRef = useRef();
  const vehIncentRef = useRef();
  const warrSaleRef = useRef();
  const warrCostRef = useRef();
  const warrTypeRef = useRef();
  const doasRef = useRef();
  const keysRef = useRef();
  const accessRef = useRef();
  const vq2Ref = useRef();
  const taxesRef = useRef();
  const transCostRef = useRef();
  const upfitCostRef = useRef();
  const ttFeesRef = useRef();
  const billNotesRef = useRef();
  const dtSentToUpfitterRef = useRef();
  const dtPDIRef = useRef();
  const manualStatusRef = useRef();
  const manualETARef = useRef();
  const mileageRef = useRef();
  const etrFeeRef = useRef();
  const finResrvRef = useRef();


  // Track dirty fields
  const [dirtyFields, setDirtyFields] = useState({});
  

  // Fetch sales orders and sort them (newest to oldest, with "Stock" at the top)
  useEffect(() => {
    console.log('salesOrderNumber', salesOrderNumber);
    const fetchSalesOrders = async () => {
      try {
        // Query the salesOrders collection where strSalesOrdStatus is "Active"
        const activeSalesOrders = await queryData('salesOrders', 'strSalesOrdStatus', '==', 'Active');


        // Sort sales orders by descending order of the sales order number (YYMMDD-XX format)
        const sortedSalesOrders = activeSalesOrders.sort((a, b) => {
          // If either of the sales orders is "Stock", prioritize it at the top
          if (a.strSalesOrdNbr === 'Stock') return -1;
          if (b.strSalesOrdNbr === 'Stock') return 1;

          // Extract date and XX portion from the sales order numbers
          const dateA = new Date(`20${a.strSalesOrdNbr.slice(0, 2)}-${a.strSalesOrdNbr.slice(2, 4)}-${a.strSalesOrdNbr.slice(4, 6)}`);
          const dateB = new Date(`20${b.strSalesOrdNbr.slice(0, 2)}-${b.strSalesOrdNbr.slice(2, 4)}-${b.strSalesOrdNbr.slice(4, 6)}`);

          // First compare by date (newest to oldest)
          if (dateA.getTime() !== dateB.getTime()) {
            return dateB - dateA;
          }

          // If dates are the same, compare by the XX part (as numbers, not strings)
          const xxA = parseInt(a.strSalesOrdNbr.slice(7), 10);
          const xxB = parseInt(b.strSalesOrdNbr.slice(7), 10);

          return xxB - xxA; // Sort from highest XX to lowest XX
        });


        setSalesOrders(sortedSalesOrders);
      } catch (error) {
        console.error('Error fetching active sales orders:', error);
      }
    };

    fetchSalesOrders();
  }, [queryData]);

  useEffect(() => {
    if (addVehicle) {
      setDirtyFields((prevState) => ({ ...prevState, strSalesOrdNbr: true }));
    }
  }, [salesOrderNumber]);

  // Fetch upfitters and upfitter status options
  useEffect(() => {
    const fetchUpfitters = async () => {
      try {
        const upfittersData = await getData('Upfitters');
        setUpfitters(upfittersData);
      } catch (error) {
        console.error('Error fetching upfitters:', error);
      }
    };

    const fetchUpfitterStatusOptions = async () => {
      try {
        const upfitterStatusData = await queryData('eventCodes', 'strFactory', '==', 'UPFITTER');
        setUpfitterStatusOptions(upfitterStatusData);
      } catch (error) {
        console.error('Error fetching upfitter status options:', error);
      }
    };

    fetchUpfitters();
    fetchUpfitterStatusOptions();
  }, [getData, queryData]);

  useEffect(() => {
    if (vehicle && vehicle.length === 1) {
      const v = vehicle[0];
      if (manualStatusRef.current) manualStatusRef.current.value = v.manualStatus || '';
      if (manualETARef.current) manualETARef.current.value = v.manualETA ? v.manualETA.toDate().toISOString().split('T')[0] : '';
      setApproved(v.approved || false);
      setApprovedBy(v.approvedBy || '');
      setApprovedByName(v.approvedByName || '');
    }
  }, [vehicle]);


  useEffect(() => {
    if (vehicle && vehicle.length === 1) {
      const v = vehicle[0];
      if (ordNbrRef.current) ordNbrRef.current.value = v.strOrdNbr || '';
      setSelectedSalesOrder(v.strSalesOrdNbr || '');
      setOriginalSalesOrder(v.strSalesOrdNbr || '');
      if (danRef.current) danRef.current.value = v.nDAN || '';
      if (poNbrRef.current) poNbrRef.current.value = v.strPONbr || '';
      if (poLineNbrRef.current) poLineNbrRef.current.value = v.strPOLineNbr || '';
      if (vinRef.current) vinRef.current.value = v.strVin || '';
      if (stockNbrRef.current) stockNbrRef.current.value = v.strStockNbr || '';
      if (yearRef.current) yearRef.current.value = v.strYR || '';
      if (makeRef.current) makeRef.current.value = v.strMake || '';
      if (modelRef.current) modelRef.current.value = v.strModel || '';
      if (engineTypeRef.current) engineTypeRef.current.value = v.strEngineType || '';
      if (colorRef.current) colorRef.current.value = v.strColor || '';
      if (manStatRef.current) manStatRef.current.value = v.strManStat || '';
      if (dtManETARef.current) dtManETARef.current.value = v.dtManETA ? v.dtManETA.toDate().toISOString().split('T')[0] : '';
      if (dtProdDateRef.current) dtProdDateRef.current.value = v.dtProdDate ? v.dtProdDate.toDate().toISOString().split('T')[0] : '';
      if (dtPaidDateRef.current) dtPaidDateRef.current.value = v.dtPaidDate ? v.dtPaidDate.toDate().toISOString().split('T')[0] : '';
      if (dropIndRef.current) dropIndRef.current.checked = v.bDropInd || false;
      if (recvDateRef.current) recvDateRef.current.value = v.dtRecvDate ? v.dtRecvDate.toDate().toISOString().split('T')[0] : '';
      if (dropLocRef.current) dropLocRef.current.value = v.strDropLoc || '';
      if (delivStatRef.current) delivStatRef.current.value = v.strDelivStat || '';
      if (delivDateRef.current) delivDateRef.current.value = v.dtDelivDate ? v.dtDelivDate.toDate().toISOString().split('T')[0] : '';
      if (delivETARef.current) delivETARef.current.value = v.dtDelivETA ? v.dtDelivETA.toDate().toISOString().split('T')[0] : '';
      if (billCDKRef.current) billCDKRef.current.checked = v.bBillCDK || false;
      if (rptDateRef.current) rptDateRef.current.value = v.dtRptDate ? v.dtRptDate.toDate().toISOString().split('T')[0] : '';
      if (recallRef.current) recallRef.current.checked = v.bRecall || false;
      if (dealNbrRef.current) dealNbrRef.current.value = v.strDealNbr || '';
      if (saleDateRef.current) saleDateRef.current.value = v.dtSaleDate ? v.dtSaleDate.toDate().toISOString().split('T')[0] : '';
      if (vehSalePriceRef.current) vehSalePriceRef.current.value = v.curVehSalePrice || '';
      if (vehMSRPRef.current) vehMSRPRef.current.value = v.curVehMSRP || '';
      if (vehCOSRef.current) vehCOSRef.current.value = v.curVehCOS || '';
      if (rebateRef.current) rebateRef.current.value = v.curRebate || '';
      if (vehIncentRef.current) vehIncentRef.current.value = v.curVehIncent || '';
      if (warrSaleRef.current) warrSaleRef.current.value = v.curWarrSale || '';
      if (warrCostRef.current) warrCostRef.current.value = v.curWarrCost || '';
      if (warrTypeRef.current) warrTypeRef.current.value = v.strWarrType || '';
      if (doasRef.current) doasRef.current.value = v.curDoas || '';
      if (keysRef.current) keysRef.current.value = v.curKeys || '';
      if (accessRef.current) accessRef.current.value = v.currAccess || '';
      if (vq2Ref.current) vq2Ref.current.value = v.curVQ2 || '';
      if (taxesRef.current) taxesRef.current.value = v.curTaxes || '';
      if (upfitCostRef.current) upfitCostRef.current.value = v.curUpfitCost || '';
      if (transCostRef.current) transCostRef.current.value = v.curTransCost || '';
      if (ttFeesRef.current) ttFeesRef.current.value = v.curTTFees || '';
      if (billNotesRef.current) billNotesRef.current.value = v.strBillNotes || '';
      if (dtSentToUpfitterRef.current) dtSentToUpfitterRef.current.value = v.dtSentToUpfitter ? v.dtSentToUpfitter.toDate().toISOString().split('T')[0] : '';
      if (dtPDIRef.current) dtPDIRef.current.value = v.dtPDI ? v.dtPDI.toDate().toISOString().split('T')[0] : '';
      if (mileageRef.current) mileageRef.current.value = v.numMileage ?? '';
      if (etrFeeRef.current) etrFeeRef.current.checked = v.bETRFee || false;
      if (finResrvRef.current) finResrvRef.current.value = v.curFinResrv ?? '';
      setFinResrv(formatCurrency(v.curFinResrv || 0));
    }
  }, [vehicle]);

  // Update values when the component is mounted or when vehicle data changes
  useEffect(() => {
    if (vehicle && vehicle.length === 1) {
      const v = vehicle[0];
      setVehSalePrice(formatCurrency(v.curVehSalePrice || 0));
      setVehMSRP(formatCurrency(v.curVehMSRP || 0));
      setVehCOS(formatCurrency(v.curVehCOS || 0));
      setRebate(formatCurrency(v.curRebate || 0));
      setWarrSale(formatCurrency(v.curWarrSale || 0));
      setWarrCost(formatCurrency(v.curWarrCost || 0));
      setVQ2(formatCurrency(v.curVQ2 || 0));
      setTaxes(formatCurrency(v.curTaxes || 0));
      setUpfitCost(formatCurrency(v.curUpfitCost || 0));
      setTransCost(formatCurrency(v.curTransCost || 0));
      setTTFees(formatCurrency(v.curTTFees || 0));
      setVehIncent(formatCurrency(v.curVehIncent || 0));
      setAccess(formatCurrency(v.currAccess || 0));
      setDoas(formatCurrency(v.curDoas || 0));
      setArrAssistance(v.arrAssistance || []);
      setArrWarranty(v.arrWarranty || []);
      setArrRebates(v.arrRebates || []);
      setArrTradeIns(v.arrTradeIns || []);
      setArrTransport(v.arrTransport || []);
      setArrAccessories(v.arrAccessories || []);
      // === UPFITTER GROUPS: seed ===
      if (Array.isArray(v.arrUpfitters)) {
        setArrUpfitters(v.arrUpfitters);
      } else if (Array.isArray(v.arrUpfitterItems)) {
        setArrUpfitters(groupUpfitterItems(v.arrUpfitterItems)); // migrate on the fly
      } else {
        setArrUpfitters([]);
      }
    }
  }, [vehicle]);

  useEffect(() => {
    if (vehicle && vehicle.length === 1 && upfitters.length > 0 && upfitterStatusOptions.length > 0) {
      const v = vehicle[0];
      if (upfitterNbrRef.current) upfitterNbrRef.current.value = v.strUpfitterNbr || '';
      if (upfitterStatusRef.current) upfitterStatusRef.current.value = v.strUpfitterStatus || '';
      if (upfitterETARef.current) upfitterETARef.current.value = v.dtUpfitterETA ? v.dtUpfitterETA.toDate().toISOString().split('T')[0] : '';
      if (upfitterCompRef.current) upfitterCompRef.current.value = v.dtUpfitterComp ? v.dtUpfitterComp.toDate().toISOString().split('T')[0] : '';
    }
  }, [vehicle, upfitters, upfitterStatusOptions]);

  // fetch the Firestore user doc for the current user
  useEffect(() => {
    if (!currentUser) return;
    // users doc id = uid (same approach you used elsewhere)
    queryData('users', '__name__', '==', currentUser.uid)
      .then(results => setUserProfile(results?.[0] || null))
      .catch(console.error);
  }, [currentUser, queryData]);

  const canApprove = !!userProfile?.billOutApprover;

  // === UPFITTER GROUPS: helpers ===
  const toInputDate = (val) => {
    if (!val) return '';
    let d = val;
    if (typeof val?.toDate === 'function') d = val.toDate(); // Firestore Timestamp
    else if (!(val instanceof Date)) d = new Date(val);
    if (Number.isNaN(d?.getTime?.())) return '';
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  const fromInputDate = (s) => (s ? new Date(s) : null);

  // Build quick lookups for selects
  const upfitterNameByNbr = React.useMemo(() => {
    const m = new Map();
    (upfitters || []).forEach(u => m.set(u.strUpfitterNbr, u.strUpfitterName));
    return m;
  }, [upfitters]);

  const upfStatusLabelByCode = React.useMemo(() => {
    const m = new Map();
    (upfitterStatusOptions || []).forEach(o => m.set(o.strManStat, o.strFactStatus));
    return m;
  }, [upfitterStatusOptions]);

  // Group older flat arrUpfitterItems -> arrUpfitters (one header with many line items)
  const groupUpfitterItems = (flat = []) => {
    const groups = [];
    const byKey = new Map();
    flat.forEach(itm => {
      const key = itm.upfitterNbr || itm.upfitter || 'UNKNOWN';
      if (!byKey.has(key)) {
        const g = {
          upfitterNbr: itm.upfitterNbr || '',
          upfitter: itm.upfitter || '',
          upfitterStatus: itm.upfitterStatus || '',
          upfitterStatusText: itm.upfitterStatusText || '',
          dtSentToUpfitter: itm.dtSentToUpfitter || null,
          dtUpfitterETA: itm.dtUpfitterETA || null,
          dtUpfitterComp: itm.dtUpfitterComp || null,
          items: [],
        };
        byKey.set(key, g);
        groups.push(g);
      }
      byKey.get(key).items.push({
        description: itm.description || '',
        amount: itm.amount || 0,
      });
    });
    return groups;
  };

  // Flatten arrUpfitters -> old arrUpfitterItems (for BillOutSheet/back-compat)
  const flattenUpfitters = (groups = []) => {
    const out = [];
    groups.forEach(g => {
      (g.items || []).forEach(itm => {
        out.push({
          upfitterNbr: g.upfitterNbr || '',
          upfitter: g.upfitter || '',
          upfitterStatus: g.upfitterStatus || '',
          upfitterStatusText: g.upfitterStatusText || '',
          dtSentToUpfitter: g.dtSentToUpfitter ? fromInputDate(toInputDate(g.dtSentToUpfitter)) : null,
          dtUpfitterETA: g.dtUpfitterETA ? fromInputDate(toInputDate(g.dtUpfitterETA)) : null,
          dtUpfitterComp: g.dtUpfitterComp ? fromInputDate(toInputDate(g.dtUpfitterComp)) : null,
          description: itm.description || '',
          amount: itm.amount || 0,
        });
      });
    });
    return out;
  };

  // === UPFITTER GROUPS: totals ===
  const upfitItemsTotal = arrUpfitters
    .reduce((sum, g) => sum + (g.items || []).reduce((s, i) => s + (parseFloat(i.amount) || 0), 0), 0)
    .toFixed(2);

  const accessoriesTotal = arrAccessories
    .reduce((sum, a) => sum + (parseFloat(a.amount) || 0), 0)
    .toFixed(2);

  const transportTotal = arrTransport
    .reduce((sum, t) => sum + (parseFloat(t.amount) || 0), 0)
    .toFixed(2);

  const rebateTotal = arrRebates
    .reduce((sum, r) => sum + (parseFloat(r.amount) || 0), 0)
    .toFixed(2);

  const warrantySaleTotal = arrWarranty
    .reduce((sum, w) => sum + (parseFloat(w.salePrice) || 0), 0)
    .toFixed(2);

  const assistanceTotal = arrAssistance
    .reduce((sum, itm) => sum + (parseFloat(itm.amount) || 0), 0)
    .toFixed(2);

  const tradeInGross = arrTradeIns
    .reduce((sum, t) => {
      const acv = parseFloat(t.acv) || 0;
      const allow = parseFloat(t.allowance) || 0;
      const payoff = parseFloat(t.payoff) || 0;
      return sum + (acv + allow - payoff);
    }, 0)
    .toFixed(2);

  // Helper to mark fields as dirty
  const handleFieldChange = (field, value) => {
    setDirtyFields((prev) => ({ ...prev, [field]: true }));
  };

  const handleSalesOrderChange = (e) => {
    const selectedOrder = e.target.value;
    setSelectedSalesOrder(selectedOrder);

    // Mark the sales order field as dirty
    setDirtyFields((prevState) => ({ ...prevState, strSalesOrdNbr: true }));
  };

  const formatDateCell = (val) => {
    if (!val) return '';
    let d = val;
    if (typeof val?.toDate === 'function') d = val.toDate();
    else if (!(val instanceof Date)) d = new Date(val);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleDateString('en-US');
  };


  const handleUpfitterChange = (e) => {
    if (upfitterNbrRef.current) {
      upfitterNbrRef.current.value = e.target.value;
    }
  };

  const handleUpfitterStatusChange = (e) => {
    if (upfitterStatusRef.current) {
      upfitterStatusRef.current.value = e.target.value;
    }
  };

  const handleUpfitterETAChange = (e) => {
    if (upfitterStatusRef.current) {
      upfitterStatusRef.current.value = e.target.value;
    }
  };

  const handleUpfitterCompChange = (e) => {
    if (upfitterStatusRef.current) {
      upfitterStatusRef.current.value = e.target.value;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);


  const updatedVehicle = {
      strOrdNbr: ordNbrRef.current?.value || '',
      strSalesOrdNbr: selectedSalesOrder,
      nDAN: danRef.current?.value || '',
      strPONbr: poNbrRef.current?.value || '',
      strPOLineNbr: poLineNbrRef.current?.value || '',
      strVin: vinRef.current?.value || '',
      strStockNbr: stockNbrRef.current?.value || '',
      strUpfitterNbr: upfitterNbrRef.current?.value || '',
      strUpfitterStatus: upfitterStatusRef.current?.value || '',
      dtUpfitterETA: upfitterETARef.current?.value ? new Date(upfitterETARef.current.value) : null,
      dtUpfitterComp: upfitterCompRef.current?.value ? new Date(upfitterCompRef.current.value) : null,
      strYR: yearRef.current?.value || '',
      strMake: makeRef.current?.value || '',
      strEngineType: engineTypeRef.current?.value || '',
      strModel: modelRef.current?.value || '',
      strColor: colorRef.current?.value || '',
      strManStat: manStatRef.current?.value || '',
      dtManETA: dtManETARef.current?.value ? new Date(dtManETARef.current.value) : null,
      dtProdDate: dtProdDateRef.current?.value ? new Date(dtProdDateRef.current.value) : null,
      dtPaidDate: dtPaidDateRef.current?.value ? new Date(dtPaidDateRef.current.value) : null,
      bDropInd: dropIndRef.current?.checked || false,
      dtRecvDate: recvDateRef.current?.value ? new Date(recvDateRef.current.value) : null,
      strDropLoc: dropLocRef.current?.value || '',
      strDelivStat: delivStatRef.current?.value || '',
      dtDelivDate: delivDateRef.current?.value ? new Date(delivDateRef.current.value) : null,
      dtSentToUpfitter: dtSentToUpfitterRef.current?.value ? new Date(dtSentToUpfitterRef.current.value) : null,
      dtPDI: dtPDIRef.current?.value ? new Date(dtPDIRef.current.value) : null,
      dtDelivETA: delivETARef.current?.value ? new Date(delivETARef.current.value) : null,
      bBillCDK: billCDKRef.current?.checked || false,
      dtRptDate: rptDateRef.current?.value ? new Date(rptDateRef.current.value) : null,
      bRecall: recallRef.current?.checked || false,
      strDealNbr: dealNbrRef.current?.value || '',
      dtSaleDate: saleDateRef.current?.value ? new Date(saleDateRef.current.value) : null,
      curVehSalePrice: parseCurrency(vehSalePriceRef.current?.value || 0),
      curVehMSRP: parseCurrency(vehMSRPRef.current?.value || 0),
      curVehCOS: parseCurrency(vehCOSRef.current?.value || 0),
      curRebate: parseCurrency(rebateRef.current?.value || 0),
      curWarrSale: parseCurrency(warrSaleRef.current?.value || 0),
      curWarrCost: parseCurrency(warrCostRef.current?.value || 0),
      strWarrType: warrTypeRef.current?.value || '',
      curDoas: parseCurrency(doasRef.current?.value || 0),
      curKeys: parseFloat(keysRef.current?.value || 0),
      currAccess: parseCurrency(accessRef.current?.value || 0),
      curVQ2: parseCurrency(vq2Ref.current?.value || 0),
      curTaxes: parseCurrency(taxesRef.current?.value || 0),
      curUpfitCost: parseCurrency(upfitCostRef.current?.value || 0),
      curTransCost: parseCurrency(transCostRef.current?.value || 0),
      curTTFees: parseCurrency(ttFeesRef.current?.value || 0),
      curVehIncent: parseCurrency(vehIncentRef.current?.value || 0),
      strBillNotes: billNotesRef.current?.value || '',
      manualStatus: manualStatusRef.current?.value || null,
      manualETA: manualETARef.current?.value ? new Date(manualETARef.current.value) : null,
      numMileage: mileageRef.current?.value ? parseInt(mileageRef.current.value, 10) : null,
      curFinResrv: parseCurrency(finResrvRef.current?.value || 0),
    };

    updatedVehicle.arrAssistance = arrAssistance;
    updatedVehicle.arrWarranty = arrWarranty;
    updatedVehicle.arrRebates = arrRebates;
    updatedVehicle.arrTradeIns = arrTradeIns;
    updatedVehicle.arrTransport = arrTransport;
    updatedVehicle.bETRFee = etrFeeRef.current?.checked || false;
    updatedVehicle.arrAccessories = arrAccessories;
    updatedVehicle.arrUpfitters = arrUpfitters;
    updatedVehicle.arrUpfitterItems = flattenUpfitters(arrUpfitters);


    // Create a copy of the initial vehicle data (the existing data before editing)
    const initialVehicle = (vehicle && vehicle.length === 1) ? vehicle[0] : {};

    // Filter updatedVehicle to only include fields that have changed (are marked as dirty)
    const changedFields = Object.keys(updatedVehicle).reduce((acc, key) => {
      if (dirtyFields[key] && updatedVehicle[key] !== initialVehicle[key]) {
        acc[key] = updatedVehicle[key];
      }
      return acc;
    }, {});

    // If no changes, do nothing
    if (Object.keys(changedFields).length === 0) {
      setLoading(false);
      return;
    }

    try {
      if (vehicle && vehicle.length === 1) {
        // Update single vehicle
        await updateData('vehicles', vehicle[0].id, changedFields);
        if (onVehicleUpdated) {
          onVehicleUpdated(changedFields);
        }
      } else if (vehicle && vehicle.length > 1) {
        // Multiple vehicle update (bulk edit)
        await onBulkEditSubmit(changedFields);
      } else {
        // Add new vehicle
        await addData('vehicles', changedFields);
        if (onVehicleAdded) {
          onVehicleAdded();
        }
      }
    } catch (err) {
      console.error("Error adding/updating vehicle:", err);
      setError('Failed to save vehicle');
    }

    setLoading(false);
  };

  // Helper to check if any field has been modified
  const isFormDirty = () => Object.values(dirtyFields).some(field => field === true);

  const renderTooltip = (props) => (
    <Tooltip {...props}>Vehicle not updated</Tooltip>
  );

  const handleApprove = async () => {
    if (!vehicle?.[0]?.id) return;
    if (!canApprove) { alert('You are not authorized to approve vehicles.'); return; }
    try {
      await updateData('vehicles', vehicle[0].id, {
        approved: true,
        approvedBy: currentUser.uid,
        approvedByName: currentUser.displayName
      });
      setApproved(true);
      setApprovedBy(currentUser.uid);
      setApprovedByName(currentUser.displayName);
    } catch (err) {
      console.error(err);
    }
  };

  const handleUnapprove = async () => {
    if (!vehicle?.[0]?.id) return;
    if (!canApprove) { alert('You are not authorized to unapprove vehicles.'); return; }
    try {
      await updateData('vehicles', vehicle[0].id, {
        approved: false,
        approvedBy: '',
        approvedByName: ''
      });
      setApproved(false);
      setApprovedBy('');
      setApprovedByName('');
    } catch (err) {
      console.error(err);
    }
  };

  const isDisabled = approved;

  return (
    <div className="mt-4" style={{ width: '100%', margin: '0 auto' }}>
      {error && <div className="alert alert-danger">{error}</div>}
      <fieldset disabled={isDisabled}>
        <Form onSubmit={handleSubmit}>
        <Row>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="salesOrdNbr">
              <FloatingLabel controlId="salesOrdNbr" label="Sales Order Number">
                <Form.Control
                  as="select"
                  value={selectedSalesOrder}
                  onChange={(e) => {
                    const selectedOrder = e.target.value;
                    setSelectedSalesOrder(selectedOrder);
                    // Ensure dirty field update happens after setting the value
                    setDirtyFields((prevState) => ({ ...prevState, strSalesOrdNbr: true }));
                  }}
                  required
                >
                  {salesOrders.map(order => (
                    <option key={order.strSalesOrdNbr} value={order.strSalesOrdNbr}>
                      {order.strSalesOrdNbr}
                    </option>
                  ))}
                </Form.Control>

              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="ordNbr">
              <FloatingLabel controlId="ordNbr" label="Order Number">
                <Form.Control type="text" ref={ordNbrRef}
                  onChange={(e) => {
                    setDirtyFields(prevState => ({ ...prevState, strOrdNbr: true }));
                  }}
                  readOnly={!addVehicle} />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="dan">
              <FloatingLabel controlId="dan" label="DAN">
                <Form.Control type="number" ref={danRef}
                  onChange={(e) => {
                    setDirtyFields(prevState => ({ ...prevState, strDan: true }));
                  }}
                  readOnly={!addVehicle} />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="vin">
              <FloatingLabel controlId="vin" label="VIN">
                <Form.Control type="text" ref={vinRef}
                  onChange={(e) => {
                    setDirtyFields(prevState => ({ ...prevState, strVin: true }));
                  }}
                  readOnly={!addVehicle}
                  style={{
                    fontSize: '12px', // Adjust font size as needed
                  }}
                />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="stockNbr">
              <FloatingLabel controlId="stockNbr" label="Stock Number">
                <Form.Control type="text" ref={stockNbrRef}
                  onChange={(e) => {
                    setDirtyFields(prevState => ({ ...prevState, strStockNbr: true }));
                  }}
                />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="poNbr">
              <FloatingLabel controlId="poNbr" label="PO Line Number">
                <Form.Control type="text" ref={poNbrRef}
                  onChange={(e) => {
                    setDirtyFields(prevState => ({ ...prevState, strPONbr: true }));
                  }}
                />
              </FloatingLabel>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="year">
              <FloatingLabel controlId="year" label="Year">
                <Form.Control type="text" ref={yearRef}
                  onChange={(e) => {
                    setDirtyFields(prevState => ({ ...prevState, strYR: true }));
                  }}
                  readOnly={!addVehicle} />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="make">
              <FloatingLabel controlId="make" label="Make">
                <Form.Control type="text" ref={makeRef}
                  onChange={(e) => {
                    setDirtyFields(prevState => ({ ...prevState, strMake: true }));
                  }}
                  readOnly={!addVehicle} />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="engineType">
              <FloatingLabel controlId="engineType" label="Engine Type">
                <Form.Select
                  ref={engineTypeRef}
                  onChange={() => setDirtyFields(prev => ({ ...prev, strEngineType: true }))}
                >
                  <option value="">(Not Set)</option>
                  <option value="Electric">Electric</option>
                  <option value="ICE">ICE</option>
                  <option value="Hybrid">Hybrid</option>
                </Form.Select>
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="model">
              <FloatingLabel controlId="model" label="Model">
                <Form.Control type="text" ref={modelRef}
                  onChange={(e) => {
                    setDirtyFields(prevState => ({ ...prevState, strModel: true }));
                  }}
                  readOnly={!addVehicle} />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="color">
              <FloatingLabel controlId="color" label="Color">
                <Form.Control type="text" ref={colorRef}
                  onChange={(e) => {
                    setDirtyFields(prevState => ({ ...prevState, strColor: true }));
                  }}
                  readOnly={!addVehicle} />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="mileage">
              <FloatingLabel controlId="mileage" label="Mileage">
                <Form.Control
                  type="number"
                  ref={mileageRef}
                  onChange={e => setDirtyFields(d => ({ ...d, numMileage: true }))}
                />
              </FloatingLabel>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="vehMSRP">
              <FloatingLabel controlId="vehMSRP" label="Vehicle MSRP">
                <Form.Control
                  type="text"
                  ref={vehMSRPRef}
                  value={editingVehMSRP ? vehMSRP : formatCurrency(parseCurrency(vehMSRP))}
                  onFocus={() => {
                    setEditingVehMSRP(true);
                    setVehMSRP(parseCurrency(vehMSRP));
                  }}
                  onBlur={() => {
                    setEditingVehMSRP(false);
                    setVehMSRP(formatCurrency(vehMSRP));
                  }}
                  onChange={(e) => {
                    const rawValue = e.target.value.replace(/[$,]/g, ''); // Remove $ and commas
                    if (!isNaN(rawValue)) {
                      setVehMSRP(rawValue)
                      setDirtyFields(prevState => ({ ...prevState, curVehMSRP: true }));
                    }
                  }}
                />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="vehSalePrice">
              <FloatingLabel controlId="vehSalePrice" label="Vehicle Sale Price">
                <Form.Control
                  type="text"
                  ref={vehSalePriceRef}
                  value={editingVehSalePrice ? vehSalePrice : formatCurrency(parseCurrency(vehSalePrice))}
                  onFocus={() => {
                    setEditingVehSalePrice(true);
                    setVehSalePrice(parseCurrency(vehSalePrice));
                  }}
                  onBlur={() => {
                    setEditingVehSalePrice(false);
                    setVehSalePrice(formatCurrency(vehSalePrice));
                  }}
                  onChange={(e) => {
                    const rawValue = e.target.value.replace(/[$,]/g, ''); // Remove $ and commas
                    if (!isNaN(rawValue)) {
                      setVehSalePrice(rawValue)
                      setDirtyFields(prevState => ({ ...prevState, curVehSalePrice: true }));
                    }
                  }}
                />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="vehCOS">
              <FloatingLabel controlId="vehCOS" label="Vehicle Cost">
                <Form.Control
                  type="text"
                  ref={vehCOSRef}
                  value={editingVehCOS ? vehCOS : formatCurrency(parseCurrency(vehCOS))}
                  onFocus={() => {
                    setEditingVehCOS(true);
                    setVehCOS(parseCurrency(vehCOS));
                  }}
                  onBlur={() => {
                    setEditingVehCOS(false);
                    setVehCOS(formatCurrency(vehCOS));
                  }}
                  onChange={(e) => {
                    const rawValue = e.target.value.replace(/[$,]/g, ''); // Remove $ and commas
                    if (!isNaN(rawValue)) {
                      setVehCOS(rawValue)
                      setDirtyFields(prevState => ({ ...prevState, curVehCOS: true }));
                    }
                  }}
                />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="vq2">
              <FloatingLabel controlId="vq2" label=" VQ2\Hold Back">
                <Form.Control
                  type="text"
                  ref={vq2Ref}
                  value={editingVQ2 ? vq2 : formatCurrency(parseCurrency(vq2))}
                  onFocus={() => {
                    setEditingVQ2(true);
                    setVQ2(parseCurrency(vq2));
                  }}
                  onBlur={() => {
                    setEditingVQ2(false);
                    setVQ2(formatCurrency(vq2));
                  }}
                  onChange={(e) => {
                    const rawValue = e.target.value.replace(/[$,]/g, ''); // Remove $ and commas
                    if (!isNaN(rawValue)) {
                      setVQ2(rawValue)
                      setDirtyFields(prevState => ({ ...prevState, curVQ2: true }));
                    }
                  }}
                />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="upfitCost">
              <FloatingLabel controlId="upfitCost" label="Upfit Cost">
                <Form.Control
                  type="text"
                  ref={upfitCostRef}
                  value={editingUpfitCost ? upfitCost : formatCurrency(parseCurrency(upfitCost))}
                  onFocus={() => {
                    setEditingUpfitCost(true);
                    setUpfitCost(parseCurrency(upfitCost));
                  }}
                  onBlur={() => {
                    setEditingUpfitCost(false);
                    setUpfitCost(formatCurrency(upfitCost));
                  }}
                  onChange={(e) => {
                    const rawValue = e.target.value.replace(/[$,]/g, ''); // Remove $ and commas
                    if (!isNaN(rawValue)) {
                      setUpfitCost(rawValue)
                      setDirtyFields(prevState => ({ ...prevState, curUpfitCost: true }));
                    }
                  }}
                />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <FloatingLabel controlId="accessoriesTotal" label="Accessories">
              <Form.Control
                type="text"
                readOnly
                value={`$${accessoriesTotal}`}
                onClick={() => setShowAccessoriesModal(true)}
                style={{ cursor: 'pointer', backgroundColor: 'azure' }}
              />
            </FloatingLabel>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="vehIncent">
              <FloatingLabel controlId="vehIncent" label="Vehicle Incentive">
                <Form.Control
                  type="text"
                  ref={vehIncentRef}
                  value={editingVehIncent ? vehIncent : formatCurrency(parseCurrency(vehIncent))}
                  onFocus={() => {
                    setEditingVehIncent(true);
                    setVehIncent(parseCurrency(vehIncent));
                  }}
                  onBlur={() => {
                    setEditingVehIncent(false);
                    setVehIncent(formatCurrency(vehIncent));
                  }}
                  onChange={(e) => {
                    const rawValue = e.target.value.replace(/[$,]/g, ''); // Remove $ and commas
                    if (!isNaN(rawValue)) {
                      setVehIncent(rawValue)
                      setDirtyFields(prevState => ({ ...prevState, curVehIncent: true }));
                    }
                  }}
                />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="ttFees">
              <FloatingLabel controlId="ttFees" label="Tag and Title Fees">
                <Form.Control
                  type="text"
                  ref={ttFeesRef}
                  value={editingTTFees ? ttFees : formatCurrency(parseCurrency(ttFees))}
                  onFocus={() => {
                    setEditingTTFees(true);
                    setTTFees(parseCurrency(ttFees));
                  }}
                  onBlur={() => {
                    setEditingTTFees(false);
                    setTTFees(formatCurrency(ttFees));
                  }}
                  onChange={(e) => {
                    const rawValue = e.target.value.replace(/[$,]/g, ''); // Remove $ and commas
                    if (!isNaN(rawValue)) {
                      setTTFees(rawValue)
                      setDirtyFields(prevState => ({ ...prevState, curTTFees: true }));
                    }
                  }}
                />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="taxes">
              <FloatingLabel controlId="taxes" label="Taxes">
                <Form.Control
                  type="text"
                  ref={taxesRef}
                  value={editingTaxes ? taxes : formatCurrency(parseCurrency(taxes))}
                  onFocus={() => {
                    setEditingTaxes(true);
                    setTaxes(parseCurrency(taxes));
                  }}
                  onBlur={() => {
                    setEditingTaxes(false);
                    setTaxes(formatCurrency(taxes));
                  }}
                  onChange={(e) => {
                    const rawValue = e.target.value.replace(/[$,]/g, ''); // Remove $ and commas
                    if (!isNaN(rawValue)) {
                      setTaxes(rawValue)
                      setDirtyFields(prevState => ({ ...prevState, curTaxes: true }));
                    }
                  }}
                />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <FloatingLabel controlId="transportTotal" label="Transport Cost">
              <Form.Control
                type="text"
                readOnly
                value={`$${transportTotal}`}
                onClick={() => setShowTransportModal(true)}
                  style={{ cursor: 'pointer', backgroundColor: 'azure' }}
              />
            </FloatingLabel>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="finResrv">
              <FloatingLabel controlId="finResrv" label="Fin Resrv">
                <Form.Control
                  type="text"
                  ref={finResrvRef}
                  value={editingFinResrv
                    ? finResrv
                    : formatCurrency(parseCurrency(finResrv))}
                  onFocus={() => {
                    setEditingFinResrv(true);
                    setFinResrv(parseCurrency(finResrv));
                  }}
                  onBlur={() => {
                    setEditingFinResrv(false);
                    setFinResrv(formatCurrency(finResrv));
                  }}
                  onChange={e => {
                    const raw = e.target.value.replace(/[$,]/g, '');
                    if (!isNaN(raw)) {
                      setFinResrv(raw);
                      setDirtyFields(d => ({ ...d, curFinResrv: true }));
                    }
                  }}
                />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="doas">
              <FloatingLabel controlId="doas" label="Contract Fee">
                <Form.Control
                  type="text"
                  ref={doasRef}
                  value={editingDoas ? doas : formatCurrency(parseCurrency(doas))}
                  onFocus={() => {
                    setEditingDoas(true);
                    setDoas(parseCurrency(doas));
                  }}
                  onBlur={() => {
                    setEditingDoas(false);
                    setDoas(formatCurrency(doas));
                  }}
                  onChange={(e) => {
                    const rawValue = e.target.value.replace(/[$,]/g, ''); // Remove $ and commas
                    if (!isNaN(rawValue)) {
                      setDoas(rawValue)
                      setDirtyFields(prevState => ({ ...prevState, curDoas: true }));
                    }
                  }}
                />
              </FloatingLabel>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={2}>
            <FloatingLabel controlId="tradeInGross" label="Trade‑In Gross">
              <Form.Control
                type="text"
                readOnly
                value={`$${tradeInGross}`}
                onClick={() => setShowTradeModal(true)}
                  style={{ cursor: 'pointer', backgroundColor: 'azure' }}
              />
            </FloatingLabel>
          </Col>
          <Col xs={12} md={2}>
            <FloatingLabel controlId="warrantyTotal" label="Warranty">
              <Form.Control
                type="text"
                readOnly
                value={`$${warrantySaleTotal}`}
                onClick={() => setShowWarrantyModal(true)}
                  style={{ cursor: 'pointer', backgroundColor: 'azure' }}
              />
            </FloatingLabel>
          </Col>
          <Col xs={12} md={2}>
            <FloatingLabel controlId="assistanceTotal" label="Assistance">
              <Form.Control
                type="text"
                readOnly
                value={`$${assistanceTotal}`}
                onClick={() => setShowAssistanceModal(true)}
                  style={{ cursor: 'pointer', backgroundColor: 'azure' }}
              />
            </FloatingLabel>
          </Col>
          <Col xs={12} md={2}>
            <FloatingLabel controlId="rebateTotal" label="Rebate Total">
              <Form.Control
                type="text"
                readOnly
                value={`$${rebateTotal}`}
                onClick={() => setShowRebateModal(true)}
                  style={{ cursor: 'pointer', backgroundColor: 'azure' }}
              />
            </FloatingLabel>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="dropLoc">
              <FloatingLabel controlId="dropLoc" label="Drop Location">
                <Form.Control type="text" ref={dropLocRef}
                  onChange={(e) => {
                    setDirtyFields(prevState => ({ ...prevState, strDropLoc: true }));
                  }}
                />
              </FloatingLabel>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="ProdDate">
              <FloatingLabel controlId="ProdDate" label="Production Date">
                <Form.Control type="date" ref={dtProdDateRef}
                  onChange={(e) => {
                    setDirtyFields(prevState => ({ ...prevState, dtProdDate: true }));
                  }}
                />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="ManETA">
              <FloatingLabel controlId="ManETA" label="Manufacturer ETA">
                <Form.Control type="date" ref={dtManETARef}
                  onChange={(e) => {
                    setDirtyFields(prevState => ({ ...prevState, dtManETA: true }));
                  }}
                />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="recvDate">
              <FloatingLabel controlId="recvDate" label="Received Date">
                <Form.Control type="date" ref={recvDateRef}
                  onChange={(e) => {
                    setDirtyFields(prevState => ({ ...prevState, dtRecvDate: true }));
                  }}
                />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="pdiDate">
              <FloatingLabel controlId="pdiDate" label="PDI Date">
                <Form.Control type="date" ref={dtPDIRef}
                  onChange={(e) => {
                    setDirtyFields(prevState => ({ ...prevState, dtPDI: true }));
                  }}
                />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="saleDate">
              <FloatingLabel controlId="saleDate" label="Sale Date">
                <Form.Control type="date" ref={saleDateRef}
                  onChange={(e) => {
                    setDirtyFields(prevState => ({ ...prevState, dtSaleDate: true }));
                  }}
                />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="delivDate">
              <FloatingLabel controlId="delivDate" label="Delivery Date">
                <Form.Control type="date" ref={delivDateRef}
                  onChange={(e) => {
                    setDirtyFields(prevState => ({ ...prevState, dtDelivDate: true }));
                  }}
                />
              </FloatingLabel>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={2}>
            <FloatingLabel controlId="upfitItemsTotal" label="Upfit Items">
              <Form.Control
                type="text"
                readOnly
                value={`$${upfitItemsTotal}`}
                onClick={() => setShowUpfitModal(true)}
                style={{ cursor: 'pointer', backgroundColor: 'azure' }}
              />
            </FloatingLabel>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="PaidDate">
              <FloatingLabel controlId="PiadDate" label="Paid Date">
                <Form.Control type="date" ref={dtPaidDateRef}
                  onChange={(e) => {
                    setDirtyFields(prevState => ({ ...prevState, dtPaidDate: true }));
                  }}
                />
              </FloatingLabel>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12}>
            <Form.Group className="mb-3" controlId="billNotes">
              <FloatingLabel controlId="billNotes" label="Bill Notes">
                <Form.Control as="textarea" ref={billNotesRef} style={{ height: '100px' }}
                  onChange={(e) => {
                    setDirtyFields(prevState => ({ ...prevState, strBillNotes: true }));
                  }}
                />
              </FloatingLabel>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="manualStatus">
              <FloatingLabel controlId="manualStatus" label="Manual Status">
                <Form.Control
                  as="select"
                  ref={manualStatusRef}
                  onChange={(e) => {
                    setManualStatus(e.target.value)
                    setDirtyFields(prevState => ({ ...prevState, manualStatus: true }));
                  }}
                  defaultValue={manualStatus}
                >
                  <option value="" style={{ backgroundColor: "white" }}>Select Status</option>
                  <option value="Ordered" style={{ backgroundColor: "white" }}>Ordered</option>
                  <option value="Scheduled" style={{ backgroundColor: "saddlebrown" }}>Scheduled</option>
                  <option value="Produced" style={{ backgroundColor: "saddlebrown" }}>Produced</option>
                  <option value="In Transit" style={{ backgroundColor: "saddlebrown" }}>In Transit</option>
                  <option value="On the Ground" style={{ backgroundColor: "orange" }}>On the Ground</option>
                  <option value="Customer Signed" style={{ backgroundColor: "yellow" }}>Customer Signed</option>
                  <option value="At Upfitter" style={{ backgroundColor: "blue" }}>At Upfitter</option>
                  <option value="Delivered" style={{ backgroundColor: "lightgreen" }}>Delivered</option>
                  <option value="Complete" style={{ backgroundColor: "green" }}>Complete</option>
                </Form.Control>
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="manualETA">
              <FloatingLabel controlId="manualETA" label="Manual ETA">
                <Form.Control
                  type="date"
                  ref={manualETARef}
                  onChange={(e) => {
                    setManualETA(new Date(e.target.value))
                    setDirtyFields(prevState => ({ ...prevState, manualETA: true }));
                  }}
                />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="manStat">
              <FloatingLabel controlId="manStat" label="Manufacturer Status">
                <Form.Control type="text" ref={manStatRef}
                  onChange={(e) => {
                    setDirtyFields(prevState => ({ ...prevState, strManStat: true }));
                  }}
                  readOnly />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col xs={12} md={4}>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="keys">
              <FloatingLabel controlId="keys" label="Keys">
                <Form.Control type="number" ref={keysRef}
                  onChange={(e) => {
                    setDirtyFields(prevState => ({ ...prevState, curKeys: true }));
                  }}
                />
              </FloatingLabel>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={2}>
            <OverlayTrigger
              placement="top"
              overlay={!isFormDirty() ? renderTooltip : <></>}
            >
              <div style={{ display: 'inline-block' }}>
                <Button
                  variant="primary"
                  type="submit"
                  disabled={loading || !isFormDirty()}
                  style={{ pointerEvents: isFormDirty() ? 'auto' : 'none' }} // Ensures tooltip shows on hover over the wrapper
                >
                  Submit
                </Button>
              </div>
            </OverlayTrigger>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="dropInd">
              <Form.Check type="checkbox" label="Drop Indicator" ref={dropIndRef}
                onChange={(e) => {
                  setDirtyFields(prevState => ({ ...prevState, bDropInd: true }));
                }}
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="billCDK">
              <Form.Check type="checkbox" label="Billed CDK" ref={billCDKRef}
                onChange={(e) => {
                  setDirtyFields(prevState => ({ ...prevState, bBillCDK: true }));
                }}
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="recall">
              <Form.Check type="checkbox" label="Recall" ref={recallRef}
                onChange={(e) => {
                  setDirtyFields(prevState => ({ ...prevState, bRecall: true }));
                }} bRecall
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Form.Group className="mb-3" controlId="etrFee">
              <Form.Check
                type="checkbox"
                label="ETR Fee"
                ref={etrFeeRef}
                onChange={() => setDirtyFields(d => ({ ...d, bETRFee: true }))}
              />
            </Form.Group>
          </Col>
          </Row>
        </Form>
      </fieldset>
      <Row className="mb-3">
        <Col>
          {!approved ? (
            canApprove ? (
              <Button variant="success" onClick={handleApprove} disabled={!currentUser}>
                Approve Vehicle
              </Button>
            ) : (
              <span className="text-muted"></span>
            )
          ) : ( // already approved
            (currentUser?.uid === approvedBy && canApprove) ? (
              <Button variant="warning" onClick={handleUnapprove}>
                Unapprove Vehicle
              </Button>
            ) : (
              <span className="text-success">Approved by {approvedByName}</span>
            )
          )}
        </Col>
      </Row>
      {teamsLoading ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
          <div>{submitMessage}</div>
        </div>
      ) : (
        <div></div>
      )}
      <Modal
        show={showUpfitModal}
        onHide={() => setShowUpfitModal(false)}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Upfitters & Items</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Add Upfitter button */}
          <div className="mb-3">
            <Button
              variant="success"
              size="sm"
              onClick={() => {
                setArrUpfitters(prev => [
                  ...prev,
                  {
                    upfitterNbr: '',
                    upfitter: '',
                    upfitterStatus: '',
                    upfitterStatusText: '',
                    dtSentToUpfitter: '',
                    dtUpfitterETA: '',
                    dtUpfitterComp: '',
                    items: [],
                  }
                ]);
                setDirtyFields(d => ({ ...d, arrUpfitters: true, arrUpfitterItems: true }));
              }}
            >
              + Add Upfitter
            </Button>
          </div>

          {arrUpfitters.length === 0 && (
            <div className="text-muted">No upfitters added yet.</div>
          )}

          {arrUpfitters.map((g, gi) => {
            const groupTotal = (g.items || []).reduce((s, i) => s + (parseFloat(i.amount) || 0), 0);
            return (
              <div key={gi} className="p-2 mb-4 border rounded">
                {/* Upfitter header (editable) */}
                <Row className="g-2 align-items-end">
                  <Col md={3}>
                    <FloatingLabel label="Upfitter Name">
                      <Form.Select
                        value={g.upfitterNbr || ''}
                        onChange={e => {
                          const nbr = e.target.value;
                          const name = upfitterNameByNbr.get(nbr) || '';
                          setArrUpfitters(prev => {
                            const next = [...prev];
                            next[gi] = { ...next[gi], upfitterNbr: nbr, upfitter: name };
                            return next;
                          });
                          setDirtyFields(d => ({ ...d, arrUpfitters: true, arrUpfitterItems: true }));
                        }}
                      >
                        <option value="">Select upfitter…</option>
                        {(upfitters || []).map((opt, i) => (
                          <option key={i} value={opt.strUpfitterNbr}>
                            {opt.strUpfitterName}
                          </option>
                        ))}
                      </Form.Select>
                    </FloatingLabel>
                  </Col>
                  <Col md={3}>
                    <FloatingLabel label="Upfitter Status">
                      <Form.Select
                        value={g.upfitterStatus || ''}
                        onChange={e => {
                          const code = e.target.value;
                          const lbl = upfStatusLabelByCode.get(code) || '';
                          setArrUpfitters(prev => {
                            const next = [...prev];
                            next[gi] = { ...next[gi], upfitterStatus: code, upfitterStatusText: lbl };
                            return next;
                          });
                          setDirtyFields(d => ({ ...d, arrUpfitters: true, arrUpfitterItems: true }));
                        }}
                      >
                        <option value="">Select status…</option>
                        {(upfitterStatusOptions || []).map((opt, i) => (
                          <option key={i} value={opt.strManStat}>
                            {opt.strFactStatus}
                          </option>
                        ))}
                      </Form.Select>
                    </FloatingLabel>
                  </Col>
                  <Col md={2}>
                    <FloatingLabel label="Sent to Upfitter">
                      <Form.Control
                        type="date"
                        value={toInputDate(g.dtSentToUpfitter)}
                        onChange={e => {
                          const val = e.target.value; // keep as YYYY-MM-DD until save
                          setArrUpfitters(prev => {
                            const next = [...prev];
                            next[gi] = { ...next[gi], dtSentToUpfitter: val };
                            return next;
                          });
                          setDirtyFields(d => ({ ...d, arrUpfitters: true, arrUpfitterItems: true }));
                        }}
                      />
                    </FloatingLabel>
                  </Col>
                  <Col md={2}>
                    <FloatingLabel label="Upfitter ETA">
                      <Form.Control
                        type="date"
                        value={toInputDate(g.dtUpfitterETA)}
                        onChange={e => {
                          const val = e.target.value;
                          setArrUpfitters(prev => {
                            const next = [...prev];
                            next[gi] = { ...next[gi], dtUpfitterETA: val };
                            return next;
                          });
                          setDirtyFields(d => ({ ...d, arrUpfitters: true, arrUpfitterItems: true }));
                        }}
                      />
                    </FloatingLabel>
                  </Col>
                  <Col md={2}>
                    <FloatingLabel label="Complete Date">
                      <Form.Control
                        type="date"
                        value={toInputDate(g.dtUpfitterComp)}
                        onChange={e => {
                          const val = e.target.value;
                          setArrUpfitters(prev => {
                            const next = [...prev];
                            next[gi] = { ...next[gi], dtUpfitterComp: val };
                            return next;
                          });
                          setDirtyFields(d => ({ ...d, arrUpfitters: true, arrUpfitterItems: true }));
                        }}
                      />
                    </FloatingLabel>
                  </Col>
                </Row>

                {/* Items table */}
                <div className="mt-3">
                  <Table bordered hover size="sm" responsive>
                    <thead>
                      <tr>
                        <th style={{ width: '60%' }}>Description</th>
                        <th style={{ width: '25%' }}>Amount</th>
                        <th style={{ width: '15%' }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {(g.items || []).map((it, ii) => (
                        <tr key={ii}>
                          <td>
                            <Form.Control
                              value={it.description}
                              onChange={e => {
                                const v = e.target.value;
                                setArrUpfitters(prev => {
                                  const next = [...prev];
                                  const items = [...(next[gi].items || [])];
                                  items[ii] = { ...items[ii], description: v };
                                  next[gi] = { ...next[gi], items };
                                  return next;
                                });
                                setDirtyFields(d => ({ ...d, arrUpfitters: true, arrUpfitterItems: true }));
                              }}
                            />
                          </td>
                          <td>
                            <Form.Control
                              type="number"
                              step="0.01"
                              value={it.amount}
                              onChange={e => {
                                const v = e.target.value;
                                setArrUpfitters(prev => {
                                  const next = [...prev];
                                  const items = [...(next[gi].items || [])];
                                  items[ii] = { ...items[ii], amount: v };
                                  next[gi] = { ...next[gi], items };
                                  return next;
                                });
                                setDirtyFields(d => ({ ...d, arrUpfitters: true, arrUpfitterItems: true }));
                              }}
                            />
                          </td>
                          <td className="text-end">
                            <Button
                              size="sm"
                              variant="danger"
                              onClick={() => {
                                setArrUpfitters(prev => {
                                  const next = [...prev];
                                  const items = [...(next[gi].items || [])].filter((_, j) => j !== ii);
                                  next[gi] = { ...next[gi], items };
                                  return next;
                                });
                                setDirtyFields(d => ({ ...d, arrUpfitters: true, arrUpfitterItems: true }));
                              }}
                            >
                              Delete
                            </Button>
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan={3}>
                          <div className="d-flex justify-content-between align-items-center">
                            <Button
                              size="sm"
                              variant="success"
                              onClick={() => {
                                setArrUpfitters(prev => {
                                  const next = [...prev];
                                  const items = [...(next[gi].items || []), { description: '', amount: '' }];
                                  next[gi] = { ...next[gi], items };
                                  return next;
                                });
                                setDirtyFields(d => ({ ...d, arrUpfitters: true, arrUpfitterItems: true }));
                              }}
                            >
                              + Add Item
                            </Button>
                            <div className="fw-semibold">Subtotal: {formatCurrency(groupTotal)}</div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>

                {/* Delete upfitter */}
                <div className="text-end">
                  <Button
                    size="sm"
                    variant="outline-danger"
                    onClick={() => {
                      setArrUpfitters(prev => prev.filter((_, idx) => idx !== gi));
                      setDirtyFields(d => ({ ...d, arrUpfitters: true, arrUpfitterItems: true }));
                    }}
                  >
                    Delete Upfitter
                  </Button>
                </div>
              </div>
            );
          })}

          <div className="text-end mt-3">
            <strong>Total: {formatCurrency(parseFloat(upfitItemsTotal))}</strong>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowUpfitModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showAssistanceModal}
        onHide={() => setShowAssistanceModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Assistance Items</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table bordered hover size="sm">
            <thead>
              <tr>
                <th>Bid #</th>
                <th>Item #</th>
                <th>Amount</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {arrAssistance.map((itm, idx) => (
                <tr key={idx}>
                  <td>{itm.bid}</td>
                  <td>{itm.item}</td>
                  <td>${parseFloat(itm.amount).toFixed(2)}</td>
                  <td>
                    <Button
                      size="sm"
                      variant="danger"
                      onClick={() => {
                        setArrAssistance(a => a.filter((_, i) => i !== idx));
                        setDirtyFields(d => ({ ...d, arrAssistance: true }));
                      }}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              ))}
              <tr>
                <td>
                  <Form.Control
                    type="text"
                    placeholder="Bid #"
                    value={newBid}
                    onChange={e => setNewBid(e.target.value)}
                  />
                </td>
                <td>
                  <Form.Control
                    type="text"
                    placeholder="Item #"
                    value={newItem}
                    onChange={e => setNewItem(e.target.value)}
                  />
                </td>
                <td>
                  <Form.Control
                    type="number"
                    placeholder="Amount"
                    value={newAmount}
                    onChange={e => setNewAmount(e.target.value)}
                  />
                </td>
                <td>
                  <Button
                    size="sm"
                    variant="success"
                    onClick={() => {
                      // append new row
                      setArrAssistance(a => [
                        ...a,
                        { bid: newBid, item: newItem, amount: newAmount }
                      ]);
                      setNewBid(''); setNewItem(''); setNewAmount('');
                      setDirtyFields(d => ({ ...d, arrAssistance: true }));
                    }}
                  >
                    Add
                  </Button>
                </td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowAssistanceModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showWarrantyModal}
        onHide={() => setShowWarrantyModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Warranty Items</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table bordered hover size="sm">
            <thead>
              <tr>
                <th>Warranty Type</th>
                <th>Sale Price</th>
                <th>Cost</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {arrWarranty.map((w, idx) => (
                <tr key={idx}>
                  <td>{w.type}</td>
                  <td>${parseFloat(w.salePrice).toFixed(2)}</td>
                  <td>${parseFloat(w.cost).toFixed(2)}</td>
                  <td>
                    <Button
                      size="sm"
                      variant="danger"
                      onClick={() => {
                        setArrWarranty(a => a.filter((_, i) => i !== idx));
                        setDirtyFields(d => ({ ...d, arrWarranty: true }));
                      }}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              ))}

              {/* new‑row inputs */}
              <tr>
                <td>
                  <Form.Control
                    placeholder="Type"
                    value={newWarrantyType}
                    onChange={e => setNewWarrantyType(e.target.value)}
                  />
                </td>
                <td>
                  <Form.Control
                    type="number"
                    placeholder="Sale Price"
                    value={newWarrantySale}
                    onChange={e => setNewWarrantySale(e.target.value)}
                  />
                </td>
                <td>
                  <Form.Control
                    type="number"
                    placeholder="Cost"
                    value={newWarrantyCost}
                    onChange={e => setNewWarrantyCost(e.target.value)}
                  />
                </td>
                <td>
                  <Button
                    size="sm"
                    variant="success"
                    onClick={() => {
                      setArrWarranty(a => [
                        ...a,
                        {
                          type: newWarrantyType,
                          salePrice: newWarrantySale,
                          cost: newWarrantyCost,
                        }
                      ]);
                      setNewWarrantyType('');
                      setNewWarrantySale('');
                      setNewWarrantyCost('');
                      setDirtyFields(d => ({ ...d, arrWarranty: true }));
                    }}
                  >
                    Add
                  </Button>
                </td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowWarrantyModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showRebateModal}
        onHide={() => setShowRebateModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Rebate Items</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table bordered hover size="sm">
            <thead>
              <tr>
                <th>Rebate #</th>
                <th>Amount</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {arrRebates.map((r, idx) => (
                <tr key={idx}>
                  <td>{r.number}</td>
                  <td>${parseFloat(r.amount).toFixed(2)}</td>
                  <td>
                    <Button
                      size="sm"
                      variant="danger"
                      onClick={() => {
                        setArrRebates(a => a.filter((_, i) => i !== idx));
                        setDirtyFields(d => ({ ...d, arrRebates: true }));
                      }}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              ))}
              <tr>
                <td>
                  <Form.Control
                    placeholder="Rebate #"
                    value={newRebateNumber}
                    onChange={e => setNewRebateNumber(e.target.value)}
                  />
                </td>
                <td>
                  <Form.Control
                    type="number"
                    placeholder="Amount"
                    value={newRebateAmount}
                    onChange={e => setNewRebateAmount(e.target.value)}
                  />
                </td>
                <td>
                  <Button
                    size="sm"
                    variant="success"
                    onClick={() => {
                      setArrRebates(a => [
                        ...a,
                        {
                          number: newRebateNumber,
                          amount: newRebateAmount
                        }
                      ]);
                      setDirtyFields(d => ({ ...d, arrRebates: true }));
                      setNewRebateNumber('');
                      setNewRebateAmount('');
                    }}
                  >
                    Add
                  </Button>
                </td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowRebateModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showTradeModal}
        onHide={() => setShowTradeModal(false)}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Trade‑In Vehicles</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table bordered hover size="sm">
            <thead>
              <tr>
                <th>VIN</th>
                <th>Year</th>
                <th>Make / Model</th>
                <th>Miles</th>
                <th>ACV</th>
                <th>Allowance</th>
                <th>Payoff</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {arrTradeIns.map((t, idx) => (
                <tr key={idx}>
                  <td>{t.vin}</td>
                  <td>{t.year}</td>
                  <td>{t.makeModel}</td>
                  <td>{t.miles}</td>
                  <td>${parseFloat(t.acv).toFixed(2)}</td>
                  <td>${parseFloat(t.allowance).toFixed(2)}</td>
                  <td>${parseFloat(t.payoff).toFixed(2)}</td>
                  <td>
                    <Button
                      size="sm"
                      variant="danger"
                      onClick={() => {
                        setArrTradeIns(a => a.filter((_, i) => i !== idx));
                        setDirtyFields(d => ({ ...d, arrTradeIns: true }));
                        }
                      }
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              ))}

              {/* New‑row inputs */}
              <tr>
                <td>
                  <Form.Control
                    placeholder="VIN"
                    value={newTradeVin}
                    onChange={e => setNewTradeVin(e.target.value)}
                  />
                </td>
                <td>
                  <Form.Control
                    type="text"
                    placeholder="Year"
                    value={newTradeYear}
                    onChange={e => setNewTradeYear(e.target.value)}
                  />
                </td>
                <td>
                  <Form.Control
                    placeholder="Make / Model"
                    value={newTradeMakeModel}
                    onChange={e => setNewTradeMakeModel(e.target.value)}
                  />
                </td>
                <td>
                  <Form.Control
                    type="number"
                    placeholder="Miles"
                    value={newTradeMiles}
                    onChange={e => setNewTradeMiles(e.target.value)}
                  />
                </td>
                <td>
                  <Form.Control
                    type="number"
                    placeholder="ACV"
                    value={newTradeACV}
                    onChange={e => setNewTradeACV(e.target.value)}
                  />
                </td>
                <td>
                  <Form.Control
                    type="number"
                    placeholder="Allowance"
                    value={newTradeAllowance}
                    onChange={e => setNewTradeAllowance(e.target.value)}
                  />
                </td>
                <td>
                  <Form.Control
                    type="number"
                    placeholder="Payoff"
                    value={newTradePayoff}
                    onChange={e => setNewTradePayoff(e.target.value)}
                  />
                </td>
                <td>
                  <Button
                    size="sm"
                    variant="success"
                    onClick={() => {
                      setArrTradeIns(a => [
                        ...a,
                        {
                          vin: newTradeVin,
                          year: newTradeYear,
                          makeModel: newTradeMakeModel,
                          miles: newTradeMiles,
                          acv: newTradeACV,
                          allowance: newTradeAllowance,
                          payoff: newTradePayoff,
                        }
                      ]);
                      // clear inputs
                      setNewTradeVin('');
                      setNewTradeYear('');
                      setNewTradeMakeModel('');
                      setNewTradeMiles('');
                      setNewTradeACV('');
                      setNewTradeAllowance('');
                      setNewTradePayoff('');
                      setDirtyFields(d => ({ ...d, arrTradeIns: true }));
                    }}
                  >
                    Add
                  </Button>
                </td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowTradeModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showTransportModal}
        onHide={() => setShowTransportModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Transport Items</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table bordered hover size="sm">
            <thead>
              <tr>
                <th>Description</th>
                <th>Amount</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {arrTransport.map((t, idx) => (
                <tr key={idx}>
                  <td>{t.description}</td>
                  <td>${parseFloat(t.amount).toFixed(2)}</td>
                  <td>
                    <Button
                      size="sm"
                      variant="danger"
                      onClick={() => {
                        setArrTransport(a => a.filter((_, i) => i !== idx));
                        setDirtyFields(d => ({ ...d, arrTransport: true }));
                      }}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              ))}

              {/* new‑row inputs */}
              <tr>
                <td>
                  <Form.Control
                    placeholder="Description"
                    value={newTransportDesc}
                    onChange={e => setNewTransportDesc(e.target.value)}
                  />
                </td>
                <td>
                  <Form.Control
                    type="number"
                    placeholder="Amount"
                    value={newTransportAmt}
                    onChange={e => setNewTransportAmt(e.target.value)}
                  />
                </td>
                <td>
                  <Button
                    size="sm"
                    variant="success"
                    onClick={() => {
                      setArrTransport(a => [
                        ...a,
                        { description: newTransportDesc, amount: newTransportAmt }
                      ]);
                      setDirtyFields(d => ({ ...d, arrTransport: true }));
                      setNewTransportDesc('');
                      setNewTransportAmt('');
                    }}
                  >
                    Add
                  </Button>
                </td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowTransportModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showAccessoriesModal}
        onHide={() => setShowAccessoriesModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Accessory Items</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table bordered hover size="sm">
            <thead>
              <tr>
                <th>Description</th>
                <th>Amount</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {arrAccessories.map((a, idx) => (
                <tr key={idx}>
                  <td>{a.description}</td>
                  <td>${parseFloat(a.amount).toFixed(2)}</td>
                  <td>
                    <Button
                      size="sm"
                      variant="danger"
                      onClick={() => {
                        setArrAccessories(curr => curr.filter((_, i) => i !== idx));
                        setDirtyFields(d => ({ ...d, arrAccessories: true }));
                      }}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              ))}

              {/* new‑row inputs */}
              <tr>
                <td>
                  <Form.Control
                    placeholder="Description"
                    value={newAccessoryDesc}
                    onChange={e => setNewAccessoryDesc(e.target.value)}
                  />
                </td>
                <td>
                  <Form.Control
                    type="number"
                    placeholder="Amount"
                    value={newAccessoryAmount}
                    onChange={e => setNewAccessoryAmount(e.target.value)}
                  />
                </td>
                <td>
                  <Button
                    size="sm"
                    variant="success"
                    onClick={() => {
                      setArrAccessories(curr => [
                        ...curr,
                        { description: newAccessoryDesc, amount: newAccessoryAmount }
                      ]);
                      setDirtyFields(d => ({ ...d, arrAccessories: true }));
                      setNewAccessoryDesc('');
                      setNewAccessoryAmount('');
                    }}
                  >
                    Add
                  </Button>
                </td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowAccessoriesModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default VehicleForm;
